/* Built In Imports */
/* External Imports */
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import { refineUrlDomain } from '@moms/Utility/utils';
/* Styles */
import DecadeSt from '@moms/styleData/DecadeSt';
import OwnSt from '@moms/styleData/OwnSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const LeftBox = ({ region, lang, sectionContent }) => {
  const title = sectionContent[0];
  const desc = sectionContent[1]?.text;
  const buttonText = sectionContent[3]?.buttonText;
  const buttonLink = sectionContent[3]?.linkUrl;
  const mobileImageData = sectionContent[4]?.mobileImage;
  return (
    <Flex
      flexDir={{ base: 'column' }}
      color={'#FFFFFF'}
      fontFamily="Geist"
      fontWeight={500}
      px="1rem"
      pb="2rem"
      mt={{ base: '0', md: '15%' }}
      w={{base:'100%', md:'535px'}}
    >
      <Text
        fontSize={{ base: '40px', md: '48px' }}
        {...DecadeSt?.[lang]?.text3} width={'90%'}
        lineHeight={'120%'}
      >
        {title.titleText}{' '}
        <Text
          as="span"
          fontSize={{ base: '40px', md: '48px' }}
          fontStyle={'italic'}
          color={'#EC1C2D'}
        >
          {title.additionalTextLine}
        </Text>{' '}
        {title.titleSubtext}
      </Text>
      <Text
        {...DecadeSt?.[lang]?.item3}
        fontSize={{ base: '16px', md: '20px' }}
        lineHeight={'150%'}
        color={'#FFFFFFCC'}
        m="10px 0 0 0"
        maxW={'335px'}
      >
        {desc}
      </Text>
      <Box>
        <StructuredTextParser
            color="#FFFFFFB2"
            str={render(sectionContent[2].body.value)}
        />
      </Box>
      {buttonLink && (
        <Box
            display={'flex'}
            alignItems={'center'}
            gap={{ base: '1.2rem', md: '1.5rem', lg: '3rem', '2xl': '2rem' }}
            mt={{ base: '2rem', md: '5rem' }}
            mb={{ base: '1.5rem', md: '0' }}
        >
            <Button
            height="auto"
            display={{ base: 'flex' }}
            as={Link}
            href={refineUrlDomain(buttonLink, region, lang) || '#'}
            maxWidth={{ base: '320px', md: '400px' }}
            fontWeight={700}
            borderWidth={'1px'}
            border={'1px solid #ffffff'}
            fontSize={{ base: '14px', md: '1rem' }}
            lineHeight={{ base: '18.2px', md: '20.8px' }}
            width={{ base: '320px', md: '100%' }}
            borderRadius={'55px'}
            fontFamily="Geist"
            color={'#ffffff'}
            bgColor={'transparent'}
            _hover={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
            _active={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
            _focus={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
            whiteSpace="normal"
            textDecor="none"
            textTransform="uppercase"
            {...OwnSt[lang].button}
            >
            {buttonText}
            </Button>
        </Box>
        )}
      <Box
        width={'100%'}
        display={{ base: 'block', md: 'none' }}
        right={{ md: '2%', lg: '8%', xl: '12%', '2xl': '20%' }}
        textAlign={'center'}
      >
        <Image
          width={'249px'}
          objectFit="contain"
          height={'100%'}
          src={mobileImageData?.url}
          alt={mobileImageData?.alt}
        />
      </Box>
    </Flex>
  );
};

const RightBox = ({ region, lang, sectionContent }) => {
  const imageData = sectionContent[3]?.image;
  const mobileImageData = sectionContent[3]?.mobileImage;
  return (
    <Box
      width={{ md: '512px', lg: '512px' }}
      height={{ md: '404px' }}
      display={{ base: 'none', md: 'block' }}
      right={{ md: '2%', lg: '2%', xl: '2%', '2xl': '4%' }}
      alignSelf="flex-end"
      position={'relative'}
    >
      <Image
        width={'100%'}
        height={'100%'}
        src={sectionContent[4].image?.url}
        alt={imageData?.alt || mobileImageData?.alt}
      />
    </Box>
  );
};

const InnerPowerLeague = ({ region, lang, sectionContent }) => {
  return (
    <Box
      minH={{ md: '540px' }}
      pos={'relative'}
      overflow={'hidden'}
      maxW={'1194px'}
      m="0 auto"
      pt={{ base: '5rem', md: '5rem' }}
    >
      <Flex
        flexDir={{ md: 'row-reverse' }}
        justifyContent={{ md: 'center' }}
        gap={{ md: '1rem', lg: '4rem' }}
        overflowY={'hidden'}
      >
        {/* Right  box  for image */}
        <RightBox region={region} lang={lang} sectionContent={sectionContent} />
        {/* left box */}
        <LeftBox region={region} lang={lang} sectionContent={sectionContent} />
      </Flex>
    </Box>
  );
};

export default InnerPowerLeague;
